import { useSnapshot } from 'valtio';
import getStateManager from '../StateManager';

export default function usePreviewFeatures() {
  return useSnapshot(getStateManager()).previewFeaturesEnabled;
}
